import React, { useCallback, useEffect, useState } from 'react';
import { View } from 'react-native';
import { PendingBanner } from '@shared/commerce';
import { walletAPI } from '../../services/walletApi';
import { pendingBreakdown, pendingSummary, type PendingSummary } from '../../utils/walletFormat';

/**
 * "Amount pending" on the home screen (owner, 16 Oct 2026): fees and wallet bills for every
 * child, in the school's currency, with Pay now. Same sums as the web parent dashboard.
 * Draws nothing when nothing is owed or the amount cannot be read. Drawn by the shared
 * customer kit (Mobile/Shared/commerce), so every app shows it the same (owner, 19 Oct 2026).
 */
export function PendingAmountBanner({ onPay, refreshKey }: { onPay: () => void; refreshKey?: number }) {
  const [pending, setPending] = useState<PendingSummary | null>(null);

  const load = useCallback(async () => {
    try { setPending(pendingSummary(await walletAPI.getPayAndTopUp())); }
    catch { setPending(null); }
  }, []);

  useEffect(() => { load(); }, [load, refreshKey]);

  if (!pending || pending.total <= 0) { return null; }
  return (
    <View style={{ marginHorizontal: 16, marginTop: 12 }}>
      <PendingBanner total={pending.total} breakdown={pendingBreakdown(pending)} currency={pending.currency}
        overdue={pending.overdue > 0} onPay={onPay} />
    </View>
  );
}
